const API_URL = process.env.REACT_APP_BASE_URL;

const urls = {
  sendEmail: `${API_URL}/sendContactEmail`,
};

export default urls;
